import { ExternalLink } from "lucide-react";
import { SOURCE_LABELS, PRIORITY_LABELS, PRIORITY_COLORS, TYPE_LABELS, safeExternalUrl, fmtShortDate } from "./growthConstants";

// Tarjeta compacta del tablero — mismo patrón visual/drag que KanbanCard (Admin.jsx) pero con
// los indicadores e info propios de una oportunidad de captación (sección 11/12 del spec).
export default function GrowthCard({ card, draggable, onDragStart, onClick }) {
  const url = safeExternalUrl(card.sourceUrl);
  const overdue = card.followUpAt && new Date(card.followUpAt) < new Date();

  return (
    <div
      draggable={draggable}
      onDragStart={draggable ? onDragStart : undefined}
      onClick={onClick}
      data-testid={`growth-card-${card.id}`}
      className={`cursor-pointer rounded-lg border bg-white p-3 shadow-sm transition hover:border-red-300 ${draggable ? "active:cursor-grabbing" : ""} ${card.stale ? "border-amber-300 bg-amber-50/50" : "border-slate-200"}`}
    >
      <div className="mb-1.5 flex items-center justify-between gap-2">
        <span className={`rounded-full border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide ${PRIORITY_COLORS[card.priority] || PRIORITY_COLORS.LOW}`}>
          {PRIORITY_LABELS[card.priority] || card.priority}
        </span>
        <span className="text-[10px] font-medium text-slate-400">{SOURCE_LABELS[card.source] || card.source}</span>
      </div>

      <div className="text-sm font-semibold leading-snug text-slate-900 line-clamp-2">{card.title}</div>
      {card.summary && <div className="mt-1 line-clamp-2 text-xs text-slate-500">{card.summary}</div>}
      {card.nextAction && <div className="mt-1.5 truncate text-xs font-medium text-red-600">→ {card.nextAction}</div>}

      <div className="mt-2 flex flex-wrap items-center gap-1.5 text-xs">
        {card.responded && <span title="Respondió">💬</span>}
        {overdue && <span title="Seguimiento vencido">⚠</span>}
        {!overdue && card.followUpAt && <span title="Seguimiento programado">⏰</span>}
        {card.registered && <span title="Registrado">✓</span>}
        {card.activated && <span title="Activado">⚡</span>}
        {card.customer && <span title="Cliente">€</span>}
        {card.stale && !overdue && <span className="text-amber-600" title="Requiere seguimiento">⚠</span>}
      </div>

      <div className="mt-2 flex items-center justify-between text-[10px] text-slate-400">
        <span className="truncate">{card.sourceUser ? `@${card.sourceUser}` : (TYPE_LABELS[card.type] || "")}</span>
        <span className="shrink-0">{fmtShortDate(card.lastActivityAt || card.foundAt)}</span>
      </div>

      {url && (
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
          className="mt-2 flex items-center gap-1 text-[11px] font-medium text-red-600 hover:text-red-700">
          Abrir fuente <ExternalLink size={11} />
        </a>
      )}
    </div>
  );
}
